import { usePlanGateStore } from '../../store/planGate';
import { useCanManageBilling } from '../../hooks/useBillingAccess';
import { planName } from '../../lib/planCatalog';
import { featureLabel, limitLabel } from '../../lib/planGates';
import { UpgradeDialog } from './UpgradeDialog';
import { PlanPickerDialog } from './PlanPickerDialog';
import { VerifyEmailDialog } from './VerifyEmailGate';

/** Mounts the app-wide upgrade dialog, plan picker and verify-email gate (never in embedded mode). */
export function PlanGateHost() {
  const { upgrade, verify, planPicker, closeUpgrade, closeVerify, closePlanPicker, openPlanPicker } = usePlanGateStore();
  const canManageBilling = useCanManageBilling();
  return (
    <>
      <UpgradeDialog
        gate={upgrade}
        canManageBilling={canManageBilling}
        onClose={closeUpgrade}
        onSeePlans={(gate) => openPlanPicker({
          highlightTier: gate.requiredTier,
          reason: gate.kind === 'feature'
            ? `${featureLabel(gate.feature).replace(/^./, (c) => c.toUpperCase())} need${/s$/.test(featureLabel(gate.feature)) ? '' : 's'} ${planName(gate.requiredTier)} or higher.`
            : `More ${limitLabel(gate.limit)} come with ${planName(gate.requiredTier)}.`,
        })}
      />
      <PlanPickerDialog
        open={!!planPicker}
        highlightTier={planPicker?.highlightTier ?? null}
        reason={planPicker?.reason ?? null}
        canManageBilling={canManageBilling}
        onClose={closePlanPicker}
      />
      <VerifyEmailDialog open={!!verify} feature={verify?.feature} onClose={closeVerify} />
    </>
  );
}
